import {
  notificationsListSchema,
  notificationSummarySchema,
  type NotificationsList,
  type NotificationSummary,
} from '@/types/api/notification'

import { apiClient } from './client'

export const NOTIFICATIONS_PAGE_SIZE = 20

/** One page of the current workspace's notifications plus the user's invites, newest first. */
export async function getNotifications(page = 0, size = NOTIFICATIONS_PAGE_SIZE): Promise<NotificationsList> {
  const response = await apiClient.get('/notifications', { params: { page, size } })
  return notificationsListSchema.parse(response.data)
}

/** Unread counts only; polled instead of the list. */
export async function getNotificationSummary(): Promise<NotificationSummary> {
  const response = await apiClient.get('/notifications/summary')
  return notificationSummarySchema.parse(response.data)
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.patch(`/notifications/${id}/read`)
}

export async function markAllRead(): Promise<void> {
  await apiClient.patch('/notifications/read-all')
}

export async function deleteNotification(id: string): Promise<void> {
  await apiClient.delete(`/notifications/${id}`)
}
